import React from "react";
import { useLanderConfig } from "../../commons/ConfigContext";
import { BannerType, sendBannerClickEvent } from "../../commons/banner";
import classes from "./AiroBuilderAd.module.scss";

const AIRO_BUILDER_BASE_URL = "https://airo-builder.godaddy.com/";

function buildAiroUrl(bannerLink?: string): string {
  const url = new URL(AIRO_BUILDER_BASE_URL);
  url.searchParams.set("itc", "airo_ai_builder_web_parked_pages");

  if (bannerLink) {
    try {
      const bannerUrl = new URL(bannerLink);
      const utmSource = bannerUrl.searchParams.get("utm_source");
      const utmMedium = bannerUrl.searchParams.get("utm_medium");
      const utmCampaign = bannerUrl.searchParams.get("utm_campaign");
      if (utmSource) url.searchParams.set("utm_source", utmSource);
      if (utmMedium) url.searchParams.set("utm_medium", utmMedium);
      if (utmCampaign) url.searchParams.set("utm_campaign", utmCampaign);
    } catch {
      // invalid banner link URL, skip UTM params
    }
  }

  return url.href;
}

export default function AiroBuilderAd() {
  const { landerConfig } = useLanderConfig();
  const bannerLink = landerConfig.lander?.banner?.link;
  const airoUrl = buildAiroUrl(bannerLink);

  return (
    <div className={ classes.airoAd }>
      <span className={ classes.airoAdBrand }>Airo AI Builder</span>
      <span className={ classes.airoAdSeparator }>&middot;</span>
      <span>
        Turn your prompt to a live web app in minutes. 50 free credits to start.
      </span>
      <a
        className={ classes.airoAdLink }
        href={ airoUrl }
        target="_blank"
        rel="noopener noreferrer"
        onClick={ () =>
          sendBannerClickEvent(BannerType.AIRO_BUILDER, landerConfig)
        }
      >
        <span>Start Building</span>
        <span className={ classes.airoAdArrow }>&rarr;</span>
      </a>
    </div>
  );
}
